import ButtonAddVariable from '@/components/ButtonAddVariable';
import CustomCard from '@/components/customCard';
import VariableTooltips from '@/components/EstimatedTextCard/VariableTooltips';
import RegularText from '@/components/RegularText';
import { BREAKPOINT } from '@/constants/enum';
import { StyledMessageText } from '@/pages/Checkout/components/MessageText/styled';
import { clickedDiscardSelector } from '@/redux/slice/appbar.slice';
import { TextField } from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

interface IProps {
  isRequired?: boolean;
  inputValue?: string;
  setInputValue?: (value: string) => void;
}

export default function MessageText({ inputValue, setInputValue, ...props }: IProps) {
  const clickedDiscard = useSelector(clickedDiscardSelector);
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.SM });
  const [error, setError] = useState('');

  const handleAddText = useCallback(
    (value: string) => {
      const newValue = (inputValue ?? '') + value;
      setInputValue?.(newValue);
      if (error) setError('');
    },
    [error, inputValue, setInputValue],
  );

  useEffect(() => {
    if (clickedDiscard) {
      if (!inputValue) setError('This field is required');
      else setError('');
    }
  }, [clickedDiscard, inputValue]);

  return (
    <StyledMessageText isMobile={isMobile}>
      <CustomCard required={props.isRequired} hasDroplist title={'Message text'}>
        <div className="mt-8">
          <RegularText>This will show below shipping method name</RegularText>
        </div>
        <div className="mt-8">
          <VariableTooltips hideCountDown hideGeography />
          <div className="mt-4 d-flex gap-8">
            <TextField
              onBlur={() => {
                if (!inputValue) setError('This field is required');
              }}
              label=""
              labelHidden
              value={inputValue || ''}
              onChange={(value) => {
                setInputValue?.(value);
                if (error) setError('');
              }}
              autoComplete="off"
              error={error}
            />
            <ButtonAddVariable
              handleAddText={handleAddText}
              listDisabledTemplate={{ countDown: true, country: true, flag: true, zipcode: true }}
              isAddSimpleText
              className="btn-add-variable"
              isHideBtnText={isMobile}
            />
          </div>
        </div>
      </CustomCard>
    </StyledMessageText>
  );
}
